import { TTeamMemberIdsDiff } from '../types/TTeamMemberIdsDiff';

type TInput = {
  persistedMemberIds: ReadonlySet<string>;
  draftMemberIds: ReadonlySet<string>;
};

export const diffTeamMemberIds = ({ persistedMemberIds, draftMemberIds }: TInput): TTeamMemberIdsDiff => ({
  added: [...draftMemberIds].filter((membershipId) => !persistedMemberIds.has(membershipId)),
  removed: [...persistedMemberIds].filter((membershipId) => !draftMemberIds.has(membershipId)),
});
